import { render, staticRenderFns } from "./PortalUserDropdown.vue?vue&type=template&id=432728c2"
import script from "./PortalUserDropdown.vue?vue&type=script&lang=js"
export * from "./PortalUserDropdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports